document.addEventListener('DOMContentLoaded', () => {
  const heroes = document.querySelectorAll('[data-sm-home-hero]');

  heroes.forEach((hero) => {
    const preloader = hero.querySelector('[data-sm-preloader]');
    const slides = Array.from(hero.querySelectorAll('[data-sm-slide]'));
    const cursor = hero.querySelector('[data-sm-cursor]');
    const delay = parseInt(hero.dataset.sliderDelay || '5000', 10);
    const preloaderDuration = parseInt(hero.dataset.preloaderDuration || '2000', 10);

    if (!slides.length) return;

    let current = 0;
    let intervalId = null;

    const isDesktop = () => window.innerWidth > 989;

    const setActiveSlide = (index) => {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      current = index;
    };

    const nextSlide = () => {
      const next = (current + 1) % slides.length;
      setActiveSlide(next);
    };

    const startSlider = () => {
      if (slides.length < 2) return;
      stopSlider();
      intervalId = window.setInterval(nextSlide, delay);
    };

    const stopSlider = () => {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    };

    const startSequence = () => {
      setActiveSlide(0);

      window.setTimeout(() => {
        hero.classList.add('is-animating');
      }, 120);

      window.setTimeout(() => {
        hero.classList.add('is-loaded');
        startSlider();
      }, preloaderDuration);
    };

    /* precarga básica */
    const imagePromises = slides.map((slide) => {
      const img = slide.querySelector('img');
      if (!img) return Promise.resolve();

      if (img.complete) return Promise.resolve();

      return new Promise((resolve) => {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    });

    Promise.all(imagePromises).then(startSequence);

    /* cursor custom desktop */
    if (cursor) {
      const moveCursor = (event) => {
        if (!isDesktop()) return;

        const rect = hero.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

hero.style.cursor = 'none';
const links = hero.querySelectorAll('.sm-home-hero__slide-link');
links.forEach((link) => {
  link.style.cursor = 'none';
});        cursor.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      };

      const showCursor = (event) => {
        if (!isDesktop()) return;

        const rect = hero.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        hero.style.cursor = 'none';
        cursor.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
        cursor.classList.add('is-visible');
      };

      const hideCursor = () => {
        cursor.classList.remove('is-visible');
hero.style.cursor = '';
const links = hero.querySelectorAll('.sm-home-hero__slide-link');
links.forEach((link) => {
  link.style.cursor = '';
});
      };

      hero.addEventListener('mousemove', moveCursor);
      hero.addEventListener('mouseenter', showCursor);
      hero.addEventListener('mouseleave', hideCursor);

      window.addEventListener('resize', () => {
        if (!isDesktop()) {
          hideCursor();
        }
      });
    }

    /* pausa opcional al cambiar de pestaña */
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopSlider();
      } else if (hero.classList.contains('is-loaded')) {
        startSlider();
      }
    });
  });
});